import { notification } from 'antd';
import { all, call, put, take } from 'redux-saga/effects';

//Component
import { history } from 'store';
import {
  LOAD_PACKAGE_LIST,
  CREATE_PACKAGE,
  LOAD_PACKAGE_DETAIL,
  UPDATE_PACKAGE,
  DELETE_PACKAGE,
} from '../type';
import {
  //List
  loadPackageListSuccessAction,
  loadPackageListErrorAction,

  //Detail
  loadPackageDetailSuccessAction,
  loadPackageDetailErrorAction,

  //Create
  createPackageSuccessAction,
  createPackageErrorAction,

  //Update
  updatePackageSuccessAction,
  updatePackageErrorAction,

  //Delete
  deletePackageSuccessAction,
  deletePackageErrorAction,
} from '../action';

import { packageService } from 'services';

function* loadPackageList() {
  while (1) {
    const action = yield take(LOAD_PACKAGE_LIST);
    try {
      const listPackage = yield call(
        packageService.loadPackageList,
        action.payload,
      );
      yield put(loadPackageListSuccessAction(listPackage));
    } catch (err) {
      yield put(loadPackageListErrorAction(err));
      notification.error({
        message: err.message,
      });
    }
  }
}

function* loadPackageDetail() {
  while (1) {
    const action = yield take(LOAD_PACKAGE_DETAIL);
    try {
      const packageDetail = yield call(
        packageService.loadPackageDetail,
        action.payload,
      );

      if (action.payload.callback) {
        action.payload.callback(packageDetail.packageDuration);
      }
      yield put(loadPackageDetailSuccessAction(packageDetail));
    } catch (err) {
      yield put(loadPackageDetailErrorAction(err));
      notification.error({
        message: err.message,
      });
    }
  }
}

function* createPackage() {
  while (1) {
    const action = yield take(CREATE_PACKAGE);
    try {
      const { callback, ignoreInsert } = action.payload;
      const response = yield call(packageService.createPackage, action.payload);

      yield put(createPackageSuccessAction(response));

      callback && callback(response);
      if (!ignoreInsert) {
        notification.success({
          message: 'Create Package Successfully',
        });
      }
    } catch (err) {
      yield put(createPackageErrorAction(err));
      notification.error({
        message: err.message,
      });
    }
  }
}

function* updatePackage() {
  while (1) {
    const action = yield take(UPDATE_PACKAGE);
    try {
      const updatedPackage = yield call(
        packageService.updatePackage,
        action.payload,
      );
      yield put(updatePackageSuccessAction(updatedPackage));
      notification.success({
        message: 'Update Package Successfully',
      });
    } catch (err) {
      yield put(updatePackageErrorAction(err));
      notification.error({
        message: err.message,
      });
    }
  }
}

function* deletePackage() {
  while (1) {
    const action = yield take(DELETE_PACKAGE);
    try {
      const deletedPackage = yield call(
        packageService.deletePackage,
        action.payload,
      );
      yield put(deletePackageSuccessAction(deletedPackage));
      notification.success({
        message: 'Delete Package Successfully',
      });
    } catch (err) {
      yield put(deletePackageErrorAction(err));
      notification.error({
        message: err.message,
      });
    }
  }
}

export default function* rootSaga() {
  yield all([
    loadPackageList(),
    createPackage(),
    loadPackageDetail(),
    updatePackage(),
    deletePackage(),
  ]);
}
